<template>
  <h1>{{ $route.meta.title }}</h1>
</template>

<script>
export default {

};
</script>